export default __webpack_public_path__ + "static/img-triple-crown-point-first-e55b18acaea41b5a2fc10c37df6f478c.avif";